import styles from './ProducerContactRequest.module.scss'
import ProducerContactRequestForm from './producer-contact-request-form/ProducerContactRequestForm'
import { Container, Header } from '@boltenergy-be/design-system'
import { useTranslation } from 'next-i18next/pages'

const ProducerContactRequest = () => {
  // i18n
  const { t } = useTranslation('b2b', { keyPrefix: 'request' })

  return (
    <main>
      <Header title={t('hero.title')} color="accent-soft" shape="s1">
        <p>{t('hero.description')}</p>
      </Header>

      <Container as="section" classnames={{ container: styles.form }}>
        <ProducerContactRequestForm />
      </Container>
    </main>
  )
}

export default ProducerContactRequest
